import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";


const EditQuestion = () => {
	const navigate = useNavigate();
	const [quesLink, setQuesLink] = useState("");
	const [tagData, setTagData] = useState();
	const [newTags, setNewTags] = useState([]);
	const [oldTagData, setOldTagData] = useState([]);
	const [oldDifficulty, setOldDifficulty] = useState('');
	const [newQuesData, setNewQuesData] = useState({
		title: "",
		link: "",
		tags: [],
		difficulty: "Easy",
		video: "",
		likes: 0,
		dislikes: 0,
	});
	const userData = useSelector((state) => state.user.user);
	//Redirect user if they're not Admin
	if (!userData.isAdmin) {
		navigate("/");
	}

	// <------------ Fetch Question from DB ------------>

	const setQuesLinkData = (e) => {
		setQuesLink(e.target.value);
	};

	const fetchQuesData = async () => {
		const response = await axios.post("/editquestion", {
			link: quesLink,
		});

		try {
			setNewQuesData({
				id: response.data[0]._id,
				difficulty: response.data[0].difficulty,
				link: response.data[0].link,
				tags: response.data[0].tags,
				title: response.data[0].title,
				video: response.data[0].video,
				likes: response.data[0].likes,
				dislikes: response.data[0].dislikes,
			});
	
			setOldTagData(response.data[0].tags);
			setOldDifficulty(response.data[0].difficulty);
			const tagResponse = await axios.get("/tags");
			setTagData(tagResponse.data.title);
		} catch (error) {
			toast("Question Not Found (maybe)");
			toast(error);
		}
	};

	//For multiple checkboxes (Tags)
	const getNewTags = (e) => {
		//Destructuring
		const { value, checked } = e.target;
		if (checked) {
			//user checks the box
			setNewTags([...newTags, value]);
		} else {
			//user uncheck the tags
			setNewTags(newTags.filter((e) => e !== value));
		}
	};

	let setInputData = (e) => {
		// set Questions data
		setNewQuesData({
			...newQuesData,
			[e.target.name]: e.target.value,
		});

	};

	useEffect(() => {
		// set updated Tags
		setNewQuesData({
			...newQuesData,
			tags: newTags,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [newTags])

	// <------------ Update Question to DB ------------>

	const handleQuesData = async () => { // On Submit
		try {
			await axios.patch('/editquestion', { newQuesData });
			navigate("/admin");
			toast.success("Question edited successfully!");
		} catch (error) {
			console.log(error);
		}
	};
	// <------------ Delete Question from DB ------------>
	const deleteQuestion = async () => {
		try {
			await axios.put('/editquestion', { data: quesLink });
			navigate("/admin");
			toast.success("Question deleted successfully!");

		} catch (error) {
			console.log(error);
		}
	}

	return (
		<>
			<div className="py-[5%] px-[5%] bg-blue2 dark:bg-dark">
				<h1 className="text-blue dark:bg-dark  bg-blue2 text-center font-bold text-4xl pt-[30px] md:text-4xl dark:text-white ">
					Edit a Question
				</h1>
				<div className="mt-[50px] flex items-center gap-5 justify-center">
					<input
						onChange={setQuesLinkData}
						value={quesLink}
						className="text-md font-medium p-3 rounded-md w-[550px] "
						placeholder="Enter question link"
					></input>

					<button
						onClick={fetchQuesData}
						className="font-medium border-2 border-blue6 rounded-sm py-2.5 px-10 bg-blue6 text-white hover:text-white hover:border-black hover:bg-black ease-in-out duration-300 dark:bg-blue dark:border-blue dark:hover:bg-dark dark:hover:text-blue"
					>
						Edit
					</button>
					<button
						onClick={deleteQuestion}
						className="font-medium border-2 border-red-600 rounded-sm py-2.5 px-10 bg-red-600 text-white hover:text-white hover:border-black hover:bg-black ease-in-out duration-300 dark:bg-red-600 dark:border-red-600 dark:hover:bg-dark dark:hover:text-red-600"
					>
						Delete
					</button>
				</div>

				<div className="mx-[10%] mt-[50px] flex flex-col items-center gap-5 justify-center">
					<div className="flex  justify-left items-center gap-5 ">
						<p className="text-darkBlue dark:bg-dark  bg-blue2 text-center font-medium text-md md:text-xl dark:text-white">
							Question Title:
						</p>
						<input
							name="title"
							onChange={setInputData}
							value={newQuesData && newQuesData.title}
							className=" w-[500px] text-md font-medium p-3 rounded-md"
						></input>
					</div>
					<div className="flex justify-left items-center gap-5 ">
						<p className="text-darkBlue dark:bg-dark  bg-blue2 text-center font-medium text-md md:text-xl dark:text-white">
							Video Link:
						</p>
						<input
							name="video"
							onChange={setInputData}
							value={newQuesData && newQuesData.video}
							className=" w-[500px] text-md font-medium p-3 rounded-md"
						></input>
					</div>

					<div className="mt-5 flex gap-5 items-center justify-center">
						<label
							className="font-medium text-xl text-dark dark:text-white mr-2 "
							htmlFor="difficulty"
						>
							Choose a difficulty:
						</label>

						<select
							className="font-medium text-md p-2"
							onChange={setInputData}
							name="difficulty"
						>
							<option value="Easy">Easy</option>
							<option value="Medium">Medium</option>
							<option value="Hard">Hard</option>
							<option value="Ninja">Ninja</option>
						</select>
						<p className="font-semibold text-xl text-dark dark:text-white">
							old difficulty: {oldDifficulty}
						</p>
					</div>

					<button
						onClick={handleQuesData}
						className="font-semibold flex items-center justify-center border-2 border-blue6 rounded-sm py-2.5 px-10 mt-10 mx-auto bg-blue6 text-white hover:text-white hover:border-black hover:bg-black ease-in-out duration-300 dark:bg-blue dark:border-blue dark:hover:bg-dark dark:hover:text-blue"
					>
						Update Question
					</button>

					<div className="mx-[10%] mt-5 flex flex-wrap gap-5">
						<div>
							<p className="font-semibold text-xl text-dark dark:text-white">
								Old Tags:
							</p>
							{oldTagData &&
								oldTagData.map((ele, idx) => {
									return (
										<p
											className="font-medium text-md text-dark dark:text-white"
											key={idx}
										>
											{ele}
										</p>
									);
								})}
						</div>
						<div>
							<p className="font-semibold text-xl text-dark dark:text-white">
								Select New Tags:
							</p>
							{tagData &&
								tagData.map((ele, key) => {
									return (
										<div key={key}>
											<input
												className="mr-2 scale-150"
												onChange={(e) => getNewTags(e)}
												id={ele}
												type="checkbox"
												name={ele}
												value={ele}
											/>
											<label
												className="font-medium text-md text-dark dark:text-white "
												htmlFor={ele}
											>
												{ele}
											</label>
										</div>
									);
								})}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default EditQuestion;
